import React, { useEffect, useState } from 'react'
import Card from '@auteco/components/sharedComponents/Card/Card'
import CardBody from '@auteco/components/sharedComponents/Card/CardBody'
import { Button, IconButton, Paper, TextField, Typography } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import { deleteGDCRoadMap } from '@auteco/services/gdcServices'
import { DeleteOutline } from '@material-ui/icons'
import { currentDate } from '@auteco/constants'
import { useStyles } from './styles'

const RoadMapCard = ({ index, item, isEnabled, onDragStart, onDragOver, onDrop, reloadGDCSRoadMap, onEditCard }) => {
  const [edit, setEdit] = useState(false)
  const [contentRoadMap, setContentRoadMap] = useState({})
  const classes = useStyles()

  const onDeleteitem = async () => {
    const { success } = await deleteGDCRoadMap({ id: item.id })
    if (success === 1) {
      reloadGDCSRoadMap()
    }
  }

  const onEditCardContent = () => {
    setEdit(prev => !prev)
  }

  const sendCardEdited = () => {
    onEditCard({ item: contentRoadMap, index })
    setEdit(false)
  }

  const updateContent = ({ param, value }) => {
    setContentRoadMap(prev => ({ ...prev, [param]: value }))
  }

  useEffect(() => {
    const newItem = { ...item }
    setContentRoadMap(newItem)
  }, [item])

  return (
    <Paper
      draggable="true"
      className={classes.paper}
      onDragStart={(event) => onDragStart(event, item, index)}
      onDragOver={onDragOver}
      onDrop={(event) => onDrop(event, index)}
      elevation={4}
    >
      <div>
        <Card className={classes.cardButton}>
          <CardBody style={{ padding: '0 0 8px' }}>
            <p className={classes.title}>{item.titulo}</p>
            <div className={classes.btnsContainer}>
              <IconButton
                className={classes.btns}
                disabled={!isEnabled}
                onClick={onEditCardContent}
              >
                <EditIcon />
              </IconButton>
              <IconButton
                className={classes.btns}
                disabled={!isEnabled}
                onClick={onDeleteitem}
              >
                <DeleteOutline />
              </IconButton>
            </div>
            <Typography className={classes.subtitle}>Descripción</Typography>
            <TextField
              type='text'
              disabled={!edit}
              value={contentRoadMap?.texto || ''}
              multiline
              className={classes.textField}
              onChange={(e) => updateContent({ param: 'texto', value: e.target.value })}
            />
            <Typography className={classes.subtitle}>Pregunta</Typography>
            <Typography style={{ fontSize: 14 }}>{item?.punto}</Typography>
            <Typography className={classes.subtitle}>Beneficio</Typography>
            <TextField
              type='number'
              disabled={!edit}
              value={contentRoadMap?.valoracion || ''}
              className={classes.textField}
              onChange={(e) => updateContent({ param: 'valoracion', value: e.target.value })}
            />
            <Typography className={classes.subtitle}>Inversión</Typography>
            <TextField
              type='number'
              disabled={!edit}
              value={contentRoadMap?.costo || ''}
              className={classes.textField}
              onChange={(e) => updateContent({ param: 'costo', value: e.target.value })}
            />
            <Typography className={classes.subtitle}>Tiempo estimado retorno de la inversión</Typography>
            <TextField
              type='date'
              disabled={!edit}
              value={contentRoadMap?.finalizacion || ''}
              className={classes.textField}
              InputProps={{
                inputProps: { min: currentDate },
              }}
              onChange={(e) => updateContent({ param: 'finalizacion', value: e.target.value })}
            />
            <Typography className={classes.subtitle}>Prioridad</Typography>
            <TextField
              type='number'
              disabled={!edit}
              value={contentRoadMap?.prioridad || ''}
              className={classes.textField}
              onChange={(e) => updateContent({ param: 'prioridad', value: e.target.value })}
            />
            {edit &&
              <Button
                color='primary'
                variant='contained'
                className={classes.updateBtn}
                onClick={sendCardEdited}
              >
                Actualizar
              </Button>
            }
          </CardBody>
        </Card>
      </div>
    </Paper >
  )
}

export { RoadMapCard }
